import css from './index.module.scss'

const Placeholder = ( { full, dark } ) => {
    return (
        <div className={`${css.placeholderLoader} ${full ? css.full : ""} ${dark ? css.dark : ""}`}></div>
    )
}

export default Placeholder